<template>
    <div class="famous-pedia-read-page">
        <!-- 顶部迷你命盘运盘部分吸顶效果 -->
        <div class="famous-pedia-fate-topbar">
            <!-- 1. 顶部菜单栏 -->
            <famous-title-bar
                v-if="!fromEmbedded"
                v-bind:fromPage="pageName"
                v-bind:titleName="curPediaBaziInfo.f_name"
                v-bind:inviteFunc="clickInvite">
            </famous-title-bar>

            <!-- 2. 迷你命盘+运盘组件 -->
            <mini-fate-fortune-panel
                v-if="showPediaCommentFateFortune"
                v-bind:fromPage="pageName"
                v-bind:fortuneItemFunc="changeFateSideListData"
                v-bind:fateSideCloseFunc="changeFateSideListData">
            </mini-fate-fortune-panel>
        </div>
        <!-- 3.1 主要内容部分 -->
        <famous-form-read
            v-if="!showPediaCommentAllList">
        </famous-form-read>

        <!-- 3.2 所有评论列表 -->
        <famous-comment-all-list 
            v-if="showPediaCommentAllList">
        </famous-comment-all-list>

        <!-- 3.3 底部背景部分 -->
        <div v-if="!showPediaCommentAllList" class="famous-pedia-read-bottom-box">
            <p v-if="!fromEmbedded">更多内容欢迎<span class="green" @click.passive="clickEdit">编辑补充</span></p>
            <p v-if="!fromEmbedded">我们共同打造世代相传的八字百科</p>
        </div>

        <!-- 4. 底部输入框:在一级评论和二级评论的时候常驻 -->
        <famous-comment-bottom-bar
            v-if="curPediaContentTab == 2 || showPediaCommentAllList">
        </famous-comment-bottom-bar>

        <!-- 5. 举报、删除、复制弹框 -->
        <famous-comment-more></famous-comment-more>

        <!-- 6. 举报弹框 -->
        <famous-comment-report></famous-comment-report>

        <!-- 7. 提示分享蒙层 -->
        <div class="layout-overlay" v-if="showSharePop">
            <div class="discuss-share-note">
                <p v-if="CONFIG.platform == 'wechat'">转发到微信群<br />邀请大家来讨论</p>
                <p v-if="CONFIG.platform == 'qq'">转发到QQ群<br />邀请大家来讨论</p>
                <div class="discuss-share-btn" @click.passive="clickKnow">知道了</div>
            </div>
        </div>

        <!-- 8. 选择分组弹框 -->
        <van-popup class="share-change-group-popup" :value="curPediaBaziShowGroupPop" @click-overlay="clickGroupPopOverlay">
            <group-change-save
                v-bind:formData="curPediaBaziNewFormData"
                v-bind:chooseFunc="clickChooseGroup"
                v-bind:confirmFunc="clickConfirmSave">
            </group-change-save>
        </van-popup>

        <!-- 9. 保存列表弹框 -->
        <van-popup class="layout-same-select-pop-box" :value="curPediaBaziShowSavePop" @click-overlay="clickSavePopOverlay">
            <famous-baike-select-pop
                v-bind:selectedList="curPediaBaziCanSaveList"
                v-bind:tellFunc="clickSaveListTell"
                v-bind:relateFunc="clickSaveListRelate"
                v-bind:saveFunc="clickSameSave">
            </famous-baike-select-pop>
        </van-popup>

        <!-- 10. 二级页面 -->
        <router-view></router-view>
    </div>
</template>

<script>
import MiniFateFortunePanel from '../../layouts/panel/MiniFateFortunePanel.vue'
import FamousTitleBar from '../../layouts/famouspedia/FamousTitleBar.vue'
import FamousFormRead from '../../layouts/famouspedia/FamousFormRead.vue'
import FamousBaikeSelectPop from '../../layouts/famouspedia/FamousBaikeSelectPop.vue'
import FamousCommentAllList from '../../layouts/famouscomment/FamousCommentAllList.vue'
import FamousCommentBottomBar from '../../layouts/famouscomment/FamousCommentBottomBar.vue'
import FamousCommentMore from '../../layouts/famouscomment/FamousCommentMore.vue'
import FamousCommentReport from '../../layouts/famouscomment/FamousCommentReport.vue'
import GroupChangeSave from '../../layouts/group/GroupChangeSave.vue'
import { FAMOUS_DOM, DOM, LOADING_DOM } from '../../modules/dom'
import { CONST_FAMOUS_PEDIA_EDIT_TYPE } from '../../modules/data/base/consts';
import { CONFIG } from '../../modules/config'
import { DATA } from '../../modules/data'
import { MIX, SCHEME } from '../../modules/utils'
export default {
    name: 'FamousPediaRead',
    components: { MiniFateFortunePanel, FamousTitleBar, FamousFormRead, FamousBaikeSelectPop, FamousCommentAllList, FamousCommentBottomBar, FamousCommentMore, FamousCommentReport, GroupChangeSave },
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        gotCurrentPediaData() {
            return this.$store.state.famouspedia.gotCurrentPediaData
        },
        curPediaContentTab() {
            return this.$store.state.famouspedia.curPediaContentTab;
        },
        curPediaBaziInfo() {
            return this.$store.state.famouspedia.curPediaBaziInfo
        },
        curPediaBaziShowGroupPop() {
            return this.$store.state.famouspedia.curPediaBaziShowGroupPop
        },
        curPediaBaziNewFormData() {
            return this.$store.state.famouspedia.curPediaBaziNewFormData
        },
        curPediaBaziShowSavePop() {
            return this.$store.state.famouspedia.curPediaBaziShowSavePop
        },
        curPediaBaziCanSaveList() {
            return this.$store.state.famouspedia.curPediaBaziCanSaveList
        },
        showPediaCommentAllList() {
            return this.$store.state.famouspediacomment.showPediaCommentAllList
        },
        showPediaCommentFateFortune() {
            return this.$store.state.famouspediacomment.showPediaCommentFateFortune
        }
    },
    data() {
        return {
            CONFIG: CONFIG,
            pageName: 'FamousPediaRead',
            showSharePop: false
        }
    },
    mounted() {
        var me = this;
        if(this.fromEmbedded) {
            setTimeout(() => {
                me.initEmbeddedFunc();
                MIX.trackPageViewed('baiKeDetail');
            }, 100);
        }
    },
    created() {
        var curpath = this.$router.history.current.path;
        if(!this.fromEmbedded && curpath.indexOf('share') == -1 && !this.gotCurrentPediaData) {
            this.$router.replace('/famouspedia');
        }
        this.$bus.on('triggerTitleLinkItem', this.triggerTitleItemFunc);
    },
    destroyed() {
        this.$bus.off('triggerTitleLinkItem', this.triggerTitleItemFunc);
    },
    methods: {
        initEmbeddedFunc() {
            var me = this;
            window.appFunc = {};
            window.appFunc.famousCallStar = function() {
                console.log('famousCallStar------')
                me.$store.dispatch('famouspedia/toggleCollectBaike', {
                    sucCCb: function() {
                        me.$toast('收藏成功');
                    },
                    sucUnCCb: function() {
                        me.$toast('取消收藏成功');
                    }
                });
            }
            window.appFunc.famousCallShare = function() {
                var famousTitle = DATA.getFamousPediaShareTextByData('wechat', me.curPediaBaziInfo);
                console.log('famousCallShare------', famousTitle, me.curPediaBaziInfo.id)
                SCHEME.configPediaShare(famousTitle, me.curPediaBaziInfo.id);
            }
        },
        // 迷你命盘运盘的数据与大运流年数据的联动
        changeFateSideListData(data, fateSideListData) {
            FAMOUS_DOM.bindFamousFormScrollEvent(false);
            var commentAllKey = this.$store.state.famouspediacomment.commentAllKey,
                commentAllYear = this.$store.state.famouspediacomment.commentAllYear,
                curPediaDayunLiunianList = this.$store.state.famouspedia.curPediaDayunLiunianList,
                showPediaCommentAllList = this.$store.state.famouspediacomment.showPediaCommentAllList,
                commentTotalReplyData = this.$store.state.famouspediacomment.commentTotalReplyData;
            if(fateSideListData.length == 0) {
                this.updateDom('');
            }else {
                if(data.type == 'dayun') {
                    this.updateDom(data.type + data.year)
                    // 更新流年的评论状态
                    this.$store.dispatch('minifatefortune/updateFamousMiniLiunianListCommentStatus', {
                        pediaList: curPediaDayunLiunianList,
                        commentData: commentTotalReplyData
                    });
                }else if(data.type == 'liunian') {
                    this.updateDom(data.type + data.year)
                    // 更新当前全部评论列表的数据
                    if(fateSideListData.length == 2) {
                        var dayunIndex = fateSideListData[0].index,
                            liunianIndex = fateSideListData[1].index, liunianYear = fateSideListData[1].year,
                            dayunData = curPediaDayunLiunianList[dayunIndex],
                            liunianData = dayunData['liunian'][liunianIndex],
                            curKey = 'big_' + dayunData.key + '_' + liunianData.key;
                        if(liunianData.content != '' && showPediaCommentAllList) {
                            this.updateCommentAllList(curKey);
                        }
                    }
                }
            }
            setTimeout(() => {
                FAMOUS_DOM.bindFamousFormScrollEvent(true);
            }, 1000);
        },
        updateCommentAllList(key) {
            var me = this,
                curId = this.$store.state.famouspedia.curPediaBaziId;
            this.$store.dispatch('famouspediacomment/setCommentFormData', {
                formData: {
                    bid: curId,
                    f_type: key,
                    parentsid: 0,
                    touid: 0
                }
            })
            this.$store.dispatch('famouspediacomment/initCommentAllListData', { 
                key: key,
                cb: function() {
                    setTimeout(() => {
                        FAMOUS_DOM.updateFamousFormStyle();
                        FAMOUS_DOM.bindFamousFormScrollEvent(false);
                        window.scrollTo(0, 0);
                    }, 20);
                }
            });
        },
        updateDom(curName) {
            var curTab = this.$store.state.famouspedia.curPediaContentTab;
            if(curTab == 1) {
                FAMOUS_DOM.updateFamousReadStoryScrollTop(curName);
            }else if(curTab == 2) {
                FAMOUS_DOM.updateFamousReadCommentScrollTop(curName);
            }
        },
        clickInvite() {
            this.showSharePop = true;
        },
        clickKnow() {
            this.showSharePop = false;
        },
        clickGroupPopOverlay() {
            this.$store.state.famouspedia.curPediaBaziShowGroupPop = false;
        },
        clickChooseGroup() {
            var curPath = this.$router.history.current.path;
                curPath = curPath + '/choosegroup';
            if(curPath.indexOf('embedded') != -1) {
                curPath = this.$router.history.current.fullPath;
                curPath = curPath.replace('famouspediaread', 'famouspediaread/choosegroup')
            }
            this.$router.replace(curPath);
            DOM.hidePageByClassName('famous-pedia-create-form');
            DOM.hidePageByClassName('famous-comment-bottom-bar');
        },
        clickSavePopOverlay() {
            this.$store.state.famouspedia.curPediaBaziShowSavePop = false;
        },
        clickSameSave() {
            this.$store.state.famouspedia.curPediaBaziShowSavePop = false;
            this.$store.state.famouspedia.curPediaBaziShowGroupPop = true;
            this.$store.state.famouspedia.curPediaBaziNewFormData['f_name'] = this.$store.state.famouspedia.curPediaBaziNewFormData['f_name'] ? state.curPediaBaziNewFormData['f_name'] : this.$store.state.famouspedia.curPediaBaziInfo['f_name'];
        },
        clickSaveListTell(data) {
            this.showSharePop = true;
        },
        clickSaveListRelate(data) {
            var me = this;
            this.$store.state.famouspedia.curPediaBaziShowSavePop = false;
            this.$store.dispatch('famouspedia/updateBaikeBaziRelate', {
                baziId: data.id,
                baikeId: this.curPediaBaziInfo.id,
                cb: function() {
                    me.$toast('已将本地八字关联至百科,从该八字点百科图标可跳转至百科');
                }
            })
        },
        clickConfirmSave() {
            var me = this;
            this.$store.dispatch('famouspedia/saveBaikeNewBazi', {
                cb: function() {
                    me.$toast('此八字已保存到八字库');
                }
            })
        },
        triggerTitleItemFunc(itemId) {
            if(itemId == '') {
                window.scrollTo(0, 0)
                return;
            }
            var me = this;
            this.$store.dispatch('minifatefortune/triggerFortuneItemFunction', itemId);
            setTimeout(() => {
                me.updateDom(itemId);
                FAMOUS_DOM.bindFamousFormScrollEvent(false);
            }, 100);
            setTimeout(() => {
                FAMOUS_DOM.bindFamousFormScrollEvent(true);
            }, 500);
        },
        clickEdit() {
            this.updateDom('');
            this.$store.state.famouspedia.curPediaEditType = CONST_FAMOUS_PEDIA_EDIT_TYPE.modify;
            var me = this,
                curPath = this.$router.history.current.fullPath;
            // console.error('clickEdit-------', curPath)
            setTimeout(() => {
                if(curPath.indexOf('embedded') != -1) {
                    curPath = curPath.replace('famouspediaread', 'famouspediaedit');
                    me.$router.replace(curPath);
                }else {
                    me.$router.replace('/famouspediaedit');
                }
                FAMOUS_DOM.bindFamousFormScrollEvent(false);
            }, 200);
        },
    }
}
</script>